// Dependencies
import styled, { css } from 'styled-components'
import { pageGutter } from 'styles/gutter'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 0 40px;
  background-color: #f0f1f7;
`

export const Content = styled.div`
  ${pageGutter}
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  ${MediaQueries.medium} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const Logo = styled.img`
  width: 140px;
  height: 40px;
`

export const SocialMediaCompositionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const LinksAndPaymentCompositionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 40px;

  ${MediaQueries.amedium} {
    display: grid;
    grid-template-columns: auto 390px;
  }
`

export const LinksCompositionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;

  ${MediaQueries.medium} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`

export const PaymentCompositionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  align-self: stretch;

  ${MediaQueries.medium} {
    flex-direction: row;
    align-items: center;
    gap: 40px;
  }

  ${MediaQueries.amedium} {
    align-items: flex-start;
    gap: 24px;
    flex-direction: column;
  }
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #ced0dd;
`

export const AddresLabel = styled.p`
  color: #666b7b;
  font-family: 'Source Sans 3';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const FooterItemContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;
`

export const FooterItemTitle = styled.p`
  color: #25272d;
  font-family: 'Source Sans 3';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`

type FooterItemContentStyleProps = {
  guidance?: 'vertical' | 'horizontal'
}

export const FooterItemContent = styled.div<FooterItemContentStyleProps>`
  display: flex;
  width: 100%;
  align-items: flex-start;
  align-self: stretch;

  > p {
    color: #666b7b;
    font-family: 'Source Sans 3';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  ${({ guidance }) =>
    guidance === 'horizontal' &&
    css`
      flex-direction: row;
      gap: 8px;
      flex-wrap: wrap;
    `}

  ${({ guidance }) =>
    guidance === 'vertical' &&
    css`
      flex-direction: column;
      gap: 4px;
    `}
`
